import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { LoggerService, OccEndpointsService, normalizeHttpError } from '@spartacus/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'

@Injectable()
export class EbRequestedShippingDateAdapter {

  protected logger = inject(LoggerService);

  constructor(
    private readonly http: HttpClient,
    private readonly occEndpoints: OccEndpointsService
  ) {}

  setRequestedShippingDate(
    cartId: string,
    userId: string,
    date: string,
    isValidationNeeded: boolean,
    changedByCustomer: boolean,
    recalculateCart: boolean
  ): Observable<any> {
    const url = this.occEndpoints.buildUrl('requestedShippingDate', {
      urlParams: { userId, cartId },
      queryParams: { isValidationNeeded, changedByCustomer, recalculateCart }
    })
    const body = JSON.stringify(date)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http
      .put(url, body, { headers })
      .pipe(catchError(error => throwError(() => normalizeHttpError(error, this.logger))))
  }
}
